import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UIView } from '@uirouter/react';
import { Button } from 'antd';
import { observer } from 'mobx-react-lite';
import { FormattedMessage } from 'react-intl';

import { Table } from '@/components/table';
import { PERMISSION_CREATE, PERMISSION_OBJ_CONTAINER } from '@/constants/permissions';
import { withPermissions } from '@/hocs/permission';
import { containerStore } from '@/stores';
import { useMassUpdateCashedStores } from '@/utils/store';

import { columns } from './setup';

const store = containerStore;

const CreateButton = withPermissions([[PERMISSION_OBJ_CONTAINER, PERMISSION_CREATE]])(({ onClick }: any) => {
  return (
    <Button onClick={onClick} type="primary" icon={<FontAwesomeIcon icon={faPlus} />}>
      <FormattedMessage id="containers.add-new" />
    </Button>
  );
});

export const Containers = observer(({ transition }: any) => {
  const items = store.items;

  useMassUpdateCashedStores([containerStore]);

  const onAdd = () => {
    transition.router.stateService.go('base-layout.containers.create');
  };

  return (
    <>
      <CreateButton onClick={onAdd} />
      <Table rowKey="id" columns={columns} dataSource={[...items]} store={store} />
      <UIView />
    </>
  );
});
